export const MESSAGE_LAST_EDIT_KEY = 'assigned_to_me.last_edit';
